import React, { useState } from 'react';
import toast from "react-hot-toast";
import { useDispatch, useSelector } from 'react-redux';
import { importPerforma } from '../actions/performaActions';
import '../style/ImportComponents.css'; // <-- import the shared CSS

const ImportExcel = () => {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.importPerforma);

  const [file, setFile] = useState(null);
  const [validationError, setValidationError] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setValidationError('');
  };

  const handleImport = (e) => {
    e.preventDefault();
    if (!file) {
      setValidationError('ابتدا فایل اکسل را انتخاب کنید.');
      toast.error('لطفاً یک فایل انتخاب کنید.');
      return;
    }
    dispatch(importPerforma(file));
  };

  return (
    <div className="import-container" dir="rtl">
      <h3>بارگذاری فایل اکسل</h3>
      <form onSubmit={handleImport}>
        <label htmlFor="order-excel-file">فایل اکسل</label>
        <input
          id="order-excel-file"
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileChange}
          className="file-input"
        />
        <button type="submit" className="import-button" disabled={loading}>
          {loading ? 'در حال بارگذاری...' : 'بارگذاری'}
        </button>
      </form>

      {validationError && <p role="alert" className="error-message">{validationError}</p>}
      {error && <p role="alert" className="error-message">{error}</p>}
      {success && <p role="status" className="success-message">{success}</p>}
    </div>
  );
};

export default ImportExcel;
